/**
 * PROinfra Shared API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { AnalyticValueIds } from '../model/models';
import { DatachangeMultiDataEdit } from '../model/models';
import { DatachangeMultiDataEdited } from '../model/models';


import { Configuration }                                     from '../configuration';



export interface DatachangeServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Gets the datachange data by multiSetId
     * This endpoint returns the data that can be edited by the given multi_type id IMPORTANT: THIS ENDPOINT IS ONLY AN INTERIM SOLUTION FOR PROIN-297 AND MUST BE REPLACED ONCE PROIN-299 IS IMPLEMENTED 
     * @param analyticProcessId ID of the analytic process
     * @param username This is the user who wants to make the changes to the data
     * @param analyticValueIds Analytic value IDs array
     */
    getDatachangeMultiEditDataByTypeId(analyticProcessId: number, username: string, analyticValueIds: AnalyticValueIds, extraHttpRequestParams?: any): Observable<DatachangeMultiDataEdit>;

    /**
     * Update the datachange data by multiSetId
     * Update the datachange data by multiSetId
     * @param multiSetId ID of the multi type with the given data
     * @param datachangeMultiDataEdited List of data
     */
    updateDatachangeMultiDataByTypeId(multiSetId: number, datachangeMultiDataEdited: DatachangeMultiDataEdited, extraHttpRequestParams?: any): Observable<Array<string>>;

}
